import * as types from './mutation-types'
import Vue from 'vue'

const mutations = {
  setLoginVisible (state, bool) {
    // state.loginVisible = bool;
    Vue.set(state, 'loginVisible', bool);
  },
  setFirstLoginVisible (state, bool) {
    Vue.set(state, 'firstLoginVisible', bool);
  },
  reset (state) {
    // state.userInfo = {};
    // state.cartNum = 0;
    Vue.set(state, 'loginVisible', false);
    Vue.set(state, 'firstLoginVisible', false);
    Vue.set(state, 'userInfo', {});
    Vue.set(state, 'firstLoginInfo', {});
    Vue.set(state, 'cartNum', 0);
  },
  setTargetRoute(state, route) {
    // state.targetRoute = route;
    Vue.set(state, 'targetRoute', route);
  },
  [types.SET_USERINFO] (state, obj) {
    // state.userInfo = obj;
    Vue.set(state, 'userInfo', obj);
  },
  [types.GET_USERINFO] (state) {
    return state.userInfo;
  },
  [types.SET_FIRSTLOGININFO] (state, obj) {
    // state.userInfo = obj;
    Vue.set(state, 'firstLoginInfo', obj);
  },
  [types.SET_CARTNUM] (state, num) {
    // state.cartNum = num;
    Vue.set(state, 'cartNum', num);
  },
  [types.GET_TARGETROUTE] (state) {
    return state.targetRoute;
  },
};

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js